import { Dialogs as DialogsType } from '../../app/dialog'
import ViewDialog from './ViewDialog'
import FileShareDialogGoogle from './FileShareDialogGoogle'
import FileShareDialogGoogleNew from './FileShareDialogGoogleNew'
import CollaborationInProgressDialog from './CollaborationInProgressDialog'
import FileShareDialogMS from './FileShareDialogMS'
import NoAcessContent from './NoAccessContent'
import JoinErrorDialog from './JoinErrorDialog'

type DialogsProps = {
  type: DialogsType
}

const Dialogs = ({ type }: DialogsProps) => {
  // add new Dialogs here and in the type in `root.ts` file
  switch (type) {
    case 'fileShareMS':
      return <FileShareDialogMS />
    // ============================= Start V3 =============================
    // Delete me to go to back to native collaboration
    case 'fileShareMSNew':
      return <FileShareDialogMS isNewDocument={true} />
    // ============================= End V3 =============================
    case 'fileShareGoogle':
      return <FileShareDialogGoogle />
    case 'fileShareGoogleNew':
      return <FileShareDialogGoogleNew />
    case 'collaborationInProgress':
    case 'collaborationInProgressNew':
      return <CollaborationInProgressDialog />
    case 'collaborationNoShare':
    case 'collaborationNoShareNew':
      return (
        <ViewDialog titleVerb='View'>
          With an active collaboration in progress, you can&apos;t share a new
          document for collaboration. Instead, you can view it in your system
          browser.
        </ViewDialog>
      )
    case 'noShare':
      return (
        <ViewDialog titleVerb='View'>
          You don&apos;t have permission to share this document in a meeting for
          collaboration. Instead, you can view it in your system browser.
        </ViewDialog>
      )
    case 'noAccess':
      return (
        <ViewDialog
          titleVerb='You need access'
          okText='Request access'
        >
          <NoAcessContent />
        </ViewDialog>
      )
    case 'joinError':
      return (
        <JoinErrorDialog
          title='Unable to join collaboration'
          content={`We couldn’t join the collaboration. Try restarting the app and attempting to join again, or return to the home screen to explore other options.
            `}
        />
      )

    default:
      return null
  }
}

export default Dialogs
